<template>
  <IconWrapper name="donut-progress" :color="color" fillMode="stroke">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="rotate: -90deg"
    >
      <circle class="donut-track" cx="12" cy="12" r="10" stroke-width="1.5" fill="transparent"></circle>
      <circle
        stroke-width="1.5"
        class="donut-path"
        cx="12"
        cy="12"
        r="10"
        fill="transparent"
        :style="`
              stroke-dasharray: ${totalLength};
              stroke-dashoffset: ${totalLength - (Math.min(100, progress) / 100) * totalLength}
              `"
      ></circle>
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

const totalLength = 62.9

const { progress = 0 } = defineProps<{
  color: ColorsType
  progress?: number
}>()
</script>

<style lang="scss">
.donut-track {
  opacity: 0.35;
}
</style>
